import { HTTPStatusCodes } from 'constants/httpStatusCodes';
import { PROCESS_TYPE } from 'features/sendouts/constants/constants';
import API from 'services/API';
import strings from 'strings';
import { Endpoints } from 'UI/constants/endpoints';
import { getErrorMessage } from 'UI/utils';

const SUBMIT_MESSAGES = strings.sendoutsV2.alerts.submitMessages;

const buildConversionAlert = ({ severity, body }) => ({
  severity,
  title: strings.formatString(SUBMIT_MESSAGES[severity].title, {
    processType: PROCESS_TYPE.Sendout.title,
    action:
      severity === 'success' ? SUBMIT_MESSAGES.actions.created : SUBMIT_MESSAGES.actions.creating
  }),
  autoHideDuration: 5000,
  ...(body ? { body } : {})
});

export const convertSendover = async ({ sendoverId, payload }) => {
  try {
    const endpoint = Endpoints.SendoverConversion.replace(':id', sendoverId);
    const response = await API.post(endpoint, payload, { apiVersion: 2 });

    if (response.status !== HTTPStatusCodes.Ok) {
      return {
        success: false,
        response,
        alert: buildConversionAlert({
          severity: 'error',
          body: strings.formatString(SUBMIT_MESSAGES.unexpectedStatus, { status: response.status })
        })
      };
    }

    return {
      success: true,
      response,
      alert: buildConversionAlert({ severity: 'success' })
    };
  } catch (error) {
    return {
      success: false,
      error,
      alert: buildConversionAlert({
        severity: 'error',
        body: getErrorMessage(error, error?.message ?? strings.shared.ui.unknownError.title)
      })
    };
  }
};
